import React, { useEffect, useRef } from 'react';
import { CDNImage } from '../../components/Elements/Image';
import './AttackPowerHud.css';
const POWER_ICON='ui/RoleIcon/power-934c90f956ed.png';

/** Megadeth and the gold/red fill + white outline used by combat FontNumbers. */
export function AttackPowerHud({power}:{power:number}) {
  const canvas=useRef<HTMLCanvasElement>(null);
  useEffect(()=>{
    let active=true;
    const draw=()=>{
      const element=canvas.current;if(!active||!element)return;
      const context=element.getContext('2d');if(!context)return;
      const text=String(power),ratio=Math.max(2,window.devicePixelRatio||1);
      context.font='32px megadeth';
      const sample=context.measureText(text),inkHeight=(sample.actualBoundingBoxAscent||24)+(sample.actualBoundingBoxDescent||0);
      const size=32*15/Math.max(1,inkHeight);
      context.font=`${size}px megadeth`;
      const measured=context.measureText(text),ascent=measured.actualBoundingBoxAscent||15;
      const descent=measured.actualBoundingBoxDescent||0,left=Math.max(0,measured.actualBoundingBoxLeft||0);
      const width=Math.ceil(Math.max(measured.width,(measured.actualBoundingBoxRight||measured.width)+left)+4);
      element.width=Math.ceil(width*ratio);element.height=20*ratio;
      element.style.width=width+'px';element.style.height='20px';
      context.scale(ratio,ratio);context.font=`${size}px megadeth`;context.lineJoin='round';context.lineWidth=1;
      const baseline=(20-ascent-descent)/2+ascent;
      const gradient=context.createLinearGradient(0,baseline-ascent,0,baseline+descent);
      gradient.addColorStop(0,'#fdbb2d');gradient.addColorStop(1,'#c33222');
      context.strokeStyle='#ffffff';context.strokeText(text,2+left,baseline);context.fillStyle=gradient;context.fillText(text,2+left,baseline);
    };
    const fonts=(document as Document&{fonts?:{load:(font:string)=>Promise<unknown>}}).fonts;
    draw();if(fonts)void fonts.load('32px megadeth').then(()=>{if(active)draw();}).catch(()=>{});
    window.addEventListener('resize',draw);return()=>{active=false;window.removeEventListener('resize',draw);};
  },[power]);
  return <div className="portrait-attack-power" role="img" aria-label={`พลังโจมตี: ${power}`} title="ค่าพลังรวมเดียวกับอันดับค่าพลัง">
    <span className="portrait-attack-power-gold">
      <CDNImage src={POWER_ICON} alt="" className="portrait-attack-power-label"/>
      <span className="portrait-attack-power-shine" aria-hidden="true" style={{WebkitMaskImage:`url(${process.env.REACT_APP_CDN_PATH??''}${POWER_ICON})`,maskImage:`url(${process.env.REACT_APP_CDN_PATH??''}${POWER_ICON})`}}/>
    </span>
    <canvas ref={canvas} className="portrait-attack-power-value" aria-hidden="true"/>
  </div>;
}
